import { Routes } from "@angular/router";
import { MeasurementStandardListComponent } from './components/measurement-standard-list/measurement-standard-list.component';
import { MeasurementStandardEditComponent } from './components/measurement-standard-edit/measurement-standard-edit.component';
import { CustomerPortalComponent } from './components/customer-portal/customer-portal.component';
import { LayoutTypeListComponent } from './components/layout-type-list/layout-type-list.component';
import { LayoutTypeEditComponent } from './components/layout-type-edit/layout-type-edit.component';
import { DoorTypeEditComponent } from './components/door-type-edit/door-type-edit.component';
import { DoorTypeListComponent } from './components/door-type-list/door-type-list.component';
import { DecorTypeListComponent } from './components/decor-type-list/decor-type-list.component';
import { DecorTypeComponent } from './components/decor-type/decor-type.component';
import { DecorListComponent } from './components/decor-list/decor-list.component';
import { DecorComponent } from './components/decor/decor.component';
import { InsideTypeListComponent } from "./components/inside-type-list/inside-type-list.component";
import { InsideTypeEditComponent } from "./components/inside-type-edit/inside-type-edit.component";
import { InsideListComponent } from "./components/inside-list/inside-list.component";
import { InsideEditComponent } from "./components/inside-edit/inside-edit.component";
import { ItemListComponent } from "./components/item-list/item-list.component";
import { ItemEditComponent } from "./components/item-edit/item-edit.component";
import { LayoutListComponent } from "./components/layout-list/layout-list.component";
import { LayoutEditComponent } from "./components/layout-edit/layout-edit.component";
import { CustomerPortalListComponent } from "./components/customer-portal-list/customer-portal-list.component";
export const moduleRoutes: Routes = [
    {
        path: 'standard',
        component: MeasurementStandardListComponent
    },
    {
        path: 'standard/add',
        component: MeasurementStandardEditComponent
    },
    {
        path: 'standard/edit/:id',
        component: MeasurementStandardEditComponent
    },
    {
        path: 'customer/add',
        component: CustomerPortalComponent
    },
    {
        path: 'customer',
        component: CustomerPortalListComponent
    },
    {
        path: 'layout-type',
        component: LayoutTypeListComponent
    },
    {
        path: 'layout-type/add',
        component: LayoutTypeEditComponent
    },
    {
        path: 'layout-type/edit/:id',
        component: LayoutTypeEditComponent
    },
    {
        path: 'door-type',
        component: DoorTypeListComponent
    },
    {
        path: 'door-type/add',
        component: DoorTypeEditComponent
    },
    {
        path: 'door-type/edit/:id',
        component: DoorTypeEditComponent
    },
    {
        path: 'inside-type',
        component: InsideTypeListComponent
    },
    {
        path: 'inside-type/add',
        component: InsideTypeEditComponent
    },
    {
        path: 'inside-type/edit/:id',
        component: InsideTypeEditComponent
    },
    {
        path: 'decor-type',
        component: DecorTypeListComponent
    },
    {
        path: 'decor-type/add',
        component: DecorTypeComponent
    },
    {
        path: 'decor-type/edit/:id',
        component: DecorTypeComponent
    },
    {
        path: 'decor',
        component: DecorListComponent
    },
    {
        path: 'decor/add',
        component: DecorComponent
    },
    {
        path: 'decor/edit/:id',
        component: DecorComponent
    },
    {
        path: 'inside',
        component: InsideListComponent
    },
    {
        path: 'inside/add',
        component: InsideEditComponent
    },
    {
        path: 'inside/edit/:id',
        component: InsideEditComponent
    },
    {
        path: 'item',
        component: ItemListComponent
    },
    {
        path: 'item/add',
        component: ItemEditComponent
    },
    {
        path: 'item/edit/:id',
        component: ItemEditComponent
    },
    {
        path: 'layout',
        component: LayoutListComponent
    },
    {
        path: 'layout/add',
        component: LayoutEditComponent
    },
    {
        path: 'layout/edit/:id',
        component: LayoutEditComponent
    }
]